import CustomVoucher from '@public/icons/voucher_new.svg';
import React, { SVGProps } from 'react';

type CustomVoucherWrapperProps = SVGProps<SVGSVGElement>;
const CustomVoucherWrapper: React.FC<CustomVoucherWrapperProps> = (props) => {
  return <CustomVoucher {...props} />;
};

export default CustomVoucherWrapper;
